import React, { useEffect } from 'react';
import { Container } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import '../Features.css';

const Sticker = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.getElementById('home').classList.add('featureContent');
    return () => {
      document.getElementById('home').classList.remove('featureContent');
    };
  });
  useEffect(() => {
    setTimeout(() => {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }, 100);
  }, []);
  return (
    <Container className="featurePages sticker">
      <div className="header">
        <div className="headerContent">
          <h2 className="title">{t('contents:stickerTitle1')}</h2>
          <p className="text">{t('contents:stickerParagraph1')}</p>
        </div>
        <img src={require('../../../assets/images/features/pages/sticker/sticker_01.svg')} />
      </div>
      <div className="content">
        <div className="container">
          <div className="section section01">
            <div className="textBox">
              <p>
                {t('contents:stickerParagraph2')}
                <br />
                <br />
                {t('contents:stickerParagraph3')}
                <br />
                <br />
              </p>
            </div>
            <div className="imageBox">
              <img src={require('../../../assets/images/features/pages/sticker/add sticker.png')} />
            </div>
          </div>
          <div className="section section02">
            <div className="textBox">
              <h2 className="title">{t('contents:stickerTitle2')} </h2>
              <p>{t('contents:stickerParagraph4')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/sticker/sticker-image-1.png')}
              />
            </div>
          </div>
          <div className="section section03">
            <div className="textBox">
              <h2 className="title">{t('contents:stickerTitle3')}</h2>
              <p>{t('contents:stickerParagraph5')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/sticker/sticker-image-3.png')}
              />
            </div>
          </div>
          <div className="section section04">
            <div className="textBox">
              <h2 className="title">{t('contents:stickerTitle4')}</h2>
              <p>{t('contents:stickerParagraph6')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/sticker/vibino-feature-Add sticker-pic4.jpg')}
              />
            </div>
          </div>
          <div className="section section05">
            <div className="textBox">
              <h2 className="title">{t('contents:stickerTitle5')}</h2>
              <p>{t('contents:stickerParagraph7')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/sticker/sticker-image-5.png')}
              />
            </div>
          </div>
          <div className="section section06">
            <div className="textBox">
              <h2 className="title">{t('contents:stickerTitle6')}</h2>
              <p>{t('contents:stickerParagraph8')}</p>
            </div>
            <div className="imageBox">
              <img
                src={require('../../../assets/images/features/pages/sticker/add sticker-asset3.png')}
              />
            </div>
          </div>
        </div>
        <div className="footer"></div>
      </div>
    </Container>
  );
};

export default Sticker;
